import { Injectable } from '@angular/core';
import { getReferrer } from '@libraries/helpers';
import { YodleeEvent, YodleeLogPayload } from '../models';
import { YodleeConfig } from '../yodlee.config';

/**
 * TODO: How can we provide for Module level instead of root.
 * Since YodleeFastlinkComponent uses this service and causing Warning: Circular dependency detected
 */

@Injectable({ providedIn: 'root' })
export class YodleeService {
  constructor(private config: YodleeConfig) {}

  updateLog(token: string, event: YodleeEvent, async = true) {
    const payload: YodleeLogPayload = {
      token,
      yodlee_event: {
        referrer: getReferrer(),
        ...event,
      },
    };

    // detect if browser supports fetch https://caniuse.com/#search=fetch
    // using fetch instead of XHR because of Chrome deprecation: https://www.chromestatus.com/feature/4664843055398912
    // more info: https://developers.google.com/web/updates/2019/12/chrome-80-deps-rems#disallow_synchronous_xmlhttprequest_in_page_dismissal
    if (window.fetch) {
      // using a fetch request instead of Angular so we can make an async call when the window unloads (Angular HTTP cancels the call)
      window.fetch(`${this.config.secureUploaderServiceUrl}/notification/bank_account`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        keepalive: true, // https://web.dev/disallow-synchronous-xhr/#fetch-keepalive
      });
    } else {
      // using a XHR request instead of Angular so we can make a synchronous call when the window unloads (Angular HTTP cancels the call)
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${this.config.secureUploaderServiceUrl}/notification/bank_account`, async);

      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.send(JSON.stringify(payload));
    }
  }
}
